export default __webpack_public_path__ + "static/media/step-3-inactivate.68c49f3e.svg";